<template>
  <partner-layout v-if="currentRole === USER_ROLE_PARTNER" class="profile">
    <partner-profile-content @update-person="handlePersonUpdate" />
  </partner-layout>

  <a-spin :spinning="!person">
    <project-manager-layout
      v-if="currentRole === USER_ROLE_LEADER"
      class="profile"
    >
      <profile-layout @update-person="handlePersonUpdate">
        <component :is="profileComponent" />
      </profile-layout>
    </project-manager-layout>

    <administrator-layout
      v-if="currentRole === USER_ROLE_ADMINISTRATOR"
      class="profile"
    >
      <profile-layout @update-person="handlePersonUpdate">
        <component :is="profileComponent" />
      </profile-layout>
    </administrator-layout>

    <moderator-layout
      v-if="currentRole === USER_ROLE_MODERATOR"
      class="profile"
    >
      <profile-layout @update-person="handlePersonUpdate">
        <component :is="profileComponent" />
      </profile-layout>
    </moderator-layout>

    <performer-projects-layout
      v-if="currentRole === USER_ROLE_PERFORMER"
      class="profile"
    >
      <profile-layout @update-person="handlePersonUpdate">
        <component :is="profileComponent" />
      </profile-layout>
    </performer-projects-layout>
  </a-spin>
</template>

<script setup>
  import { computed, ref, watch } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import PartnerLayout from '@/layouts/PartnerLayout';
  import ProjectManagerLayout from '@/layouts/ProjectManagerLayout';
  import AdministratorLayout from '@/layouts/AdministratorLayout';
  import ModeratorLayout from '@/layouts/ModeratorLayout';
  import PerformerProjectsLayout from '@/views/performer/layouts/PerformerProjectsLayout';
  import PartnerProfileContent from '@/views/partner/profile/PartnerProfileContent.vue';
  import ProfileLayout from '@/views/profile/ProfileLayout.vue';
  import ProfileProjects from '@/views/profile/components/ProfileProjects.vue';
  import ProfileEducation from '@/views/profile/components/ProfileEducation.vue';
  import ProfileResearch from '@/views/profile/components/ProfileResearch.vue';
  import ProfileVolunteering from '@/views/profile/components/ProfileVolunteering.vue';
  import ProfileMentions from '@/views/profile/components/ProfileMentions.vue';
  import {
    USER_ROLE_LEADER,
    USER_ROLE_PARTNER,
    USER_ROLE_MODERATOR,
    USER_ROLE_ADMINISTRATOR,
    USER_ROLE_PERFORMER,
  } from '@/api/models/UserRole';
  import ProfileCommonInfo from '@/views/profile/components/ProfileCommonInfo.vue';
  import ProfileStudentResearch from '@/views/profile/components/ProfileStudentResearch.vue';
  import ProfileTeaching from '@/views/profile/components/ProfileTeaching.vue';

  const route = useRoute();
  const router = useRouter();
  const person = ref(null);
  const currentRole = computed(() => localStorage.getItem('currentRole'));

  const profileComponent = computed(() => {
    if (!person.value) return null;

    const isStudent = person.value.isStudent;
    switch (route.name) {
      case 'profile-common-info':
        return ProfileCommonInfo;
      case 'profile-education':
        return ProfileEducation;
      case 'profile-teaching':
        return ProfileTeaching;
      case 'profile-research':
        return ProfileResearch;
      case 'profile-student-research':
        return ProfileStudentResearch;
      case 'profile-projects':
        return ProfileProjects;
      case 'profile-volunteering':
        return ProfileVolunteering;
      case 'profile-mentions':
        return ProfileMentions;
      default:
        return isStudent ? ProfileProjects : ProfileResearch;
    }
  });

  // Переключаемся на таб-фильтр по умолчанию, как только получим данные
  watch(
    () => person.value,
    async () => {
      if (
        route.name === 'profile' &&
        currentRole.value !== USER_ROLE_PARTNER &&
        !!person.value
      ) {
        if (person.value.isStudent) {
          await router.push({ name: 'profile-projects' });
        } else {
          await router.push({ name: 'profile-research' });
        }
      }
    }
  );

  const handlePersonUpdate = (value) => {
    person.value = value;
  };
</script>

<style lang="scss" scoped></style>
